// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ebcc38f","455":"2d2d1317","977":"9ef117a4"}[chunkId] + ".chunk.js";
};